import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {AppState} from "../../../shared/state/app.state";
import {
  getAllBlobFileMetaData, getAllBlobFileMetaDataFailure, getAllBlobFileMetaDataSuccess,

} from "./blob-file.action";
import {BlobFileService} from "../../data-access/blob-file.service";
import {BlobFileMetaData} from "../../models/blob-file.model";


@Injectable()
export class BlobFileEffects {

  getAllBlobFileMetaData = createEffect(() =>
    this.actions$.pipe(
      ofType(getAllBlobFileMetaData),
      switchMap(() =>
        this.tenantService.get()
          .pipe(
            map((blobFileMetaData: BlobFileMetaData[]) => getAllBlobFileMetaDataSuccess({blobFileMetaData: blobFileMetaData})),
            catchError((error) => of(getAllBlobFileMetaDataFailure({ error })))
          )
      )
    )
  );



  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private tenantService: BlobFileService
  ) {}
}
